import React from 'react'

const Logo = () => {
  return (
    <svg
      className="logo"
      width="304.66"
      height="40.4"
      viewBox="0 0 304.66 40.4"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Partisans</title>

      <path
        fill="white"
        d="M184,389.87v-.22c0-8.33-5-13.1-15.73-13.1H153.38v39.2h11.18V402.53h4.22C178.49,402.53,184,398.09,184,389.87Zm-10.69.05c0,3.24-1.92,4.94-5.53,4.94h-3.24V385h3.29c3.51,0,5.48,1.37,5.48,4.72Z"
        transform="translate(-153.38 -376)"
      />

      <path
        fill="white"
        d="M192.43,376.55l-12.56,39.2h10.48l2.08-7.3h13l2.09,7.3H219.4L207,376.55Zm2.19,24.17L199,385.65l4.28,15.07Z"
        transform="translate(-153.38 -376)"
      />

      <path
        fill="white"
        d="M253.22,389.21V389c0-8.28-5.7-12.44-15.95-12.44H221.92v39.2H233.1v-14h2.63l8,14h11.84l-9.37-16.23C250.26,397.93,253.22,394.8,253.22,389.21Zm-10.85.44c0,3.18-1.87,4.77-5.65,4.77H233.1V385h3.67c3.62,0,5.6,1.26,5.6,4.44Z"
        transform="translate(-153.38 -376)"
      />

      <polygon
        fill="white"
        points="101.68 9.21 111.82 9.21 111.82 39.75 123.11 39.75 123.11 9.21 141.7 9.21 141.7 31.21 135.6 31.21 135.6 39.83 157.6 39.83 157.6 31.21 151.46 31.21 151.46 9.21 157.6 9.21 157.6 0.55 101.68 0.55 101.68 9.21"
      />

      <path
        fill="white"
        d="M330.67,391.19c-4.87-.66-6.08-1.65-6.08-3.84,0-2,1.53-3.35,4.55-3.35s4.66,1.43,5,4.23H344.6c-.71-8.28-6-12.23-15.46-12.23S314,381.15,314,388.23c0,7.89,3.73,11.18,14.81,12.49,4.71.72,6.19,1.38,6.19,3.79s-1.81,3.89-5,3.89c-4.66,0-5.92-2.3-6.2-5.1H313c.33,8.5,5.92,13.1,16.89,13.1,10.08,0,15.79-5.86,15.79-13C345.7,394.86,340.6,392.28,330.67,391.19Z"
        transform="translate(-153.38 -376)"
      />

      <path
        fill="white"
        d="M357.44,376.55l-12.56,39.2h10.47l2.09-7.3h13l2.08,7.3h11.9L372,376.55Zm2.19,24.17L364,385.65l4.28,15.07Z"
        transform="translate(-153.38 -376)"
      />

      <polygon
        fill="white"
        points="258.86 22.64 246.3 0.55 233.64 0.55 233.64 39.75 243.5 39.75 243.5 15.13 257.81 39.75 268.67 39.75 268.67 0.55 258.86 0.55 258.86 22.64"
      />

      <path
        fill="white"
        d="M443,391.19c-4.88-.66-6.09-1.65-6.09-3.84,0-2,1.54-3.35,4.55-3.35s4.66,1.43,5,4.23h10.42c-.71-8.28-6-12.23-15.46-12.23s-15.18,5.15-15.18,12.23c0,7.89,3.72,11.18,14.8,12.49,4.71.72,6.19,1.38,6.19,3.79s-1.81,3.89-5,3.89c-4.66,0-5.92-2.3-6.2-5.1H425.36c.33,8.5,5.92,13.1,16.89,13.1,10.09,0,15.79-5.86,15.79-13C458,394.86,452.94,392.28,443,391.19Z"
        transform="translate(-153.38 -376)"
      />
    </svg>
  )
}

export default Logo
